import { forwardRef } from 'preact/compat'

import Icon from '@/components/snippets/icon/icon'

export const SearchInput = forwardRef(({ onInput, redirect }, ref) => {
  return (
    <div className="border-none field-control field-xl ">
      <input
        ref={ref}
        onInput={onInput}
        className="px-4 field-input field-xl placeholder-brand-black"
        type="text"
        name="query"
        placeholder="Search"
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault()
            if (redirect) {
              window.location.href = redirect
            } else {
              window.location.href = `/search?query=${e.target.value}`
            }
          }
        }}
      />
      <Icon id="magnifying-glass" className="field-icon group-data-visible/search:hidden" />
    </div>
  )
})
